import { Component, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from '@angular/router';

@Component({
    templateUrl: "./albtelecom-service.component.html"
})

export class AlbtelecomServiceComponent implements OnDestroy {
    searchForm: FormGroup;
    constructor(
        private router: Router,
        private fb: FormBuilder
    ) {
        this.searchForm = this.fb.group({
            contractNumber: [""],
            type: [1]
        });
    }

    ngOnDestroy(): void {
        // throw new Error("Method not implemented.");
    }

    onRefill(): void {
        this.router.navigate(['services/albtelecom']);
    }

    onPayment(): void {
        this.router.navigate(['services/albtelecomcontract']);
    }
}